import { createSlice } from '@reduxjs/toolkit';
import {
  createImgUpscalingTaskFromGallery,
  createImgUpscalingTaskFromUploaded,
  getImgUpscalingTaskList,
  goToTheImgUpscalingTask,
  removeImgUpscalingTask,
  sendImgUpscalingImageFeedback,
} from './operations';

import { TESTTASK_ID, TEST_IMAGE_ID } from 'utils/configs';

import defaultInputImage from 'media/images/test_input.jpg';

const defaultTask = {
  id: TESTTASK_ID,
  images: [
    {
      id: TEST_IMAGE_ID,
      input_image: defaultInputImage,
      input_image_small: defaultInputImage,
      input_image_large: defaultInputImage,
      result_image: defaultInputImage,
      result_image_basic: defaultInputImage,
      result_image_large: defaultInputImage,
    },
  ],
  status: 'test',
};

let imageUpscalingInitialState = {
  upscalingTaskList: [],
  upscalingTaskDetails: null,
  upscalingTaskStatus: null,
  upscalingIsLoading: false,
  upscalingResponseErrorMessage: null,
};

const handlePending = state => {
  state.upscalingResponseErrorMessage = null;
  state.upscalingIsLoading = true;
};

const handleRejected = (state, { payload }) => {
  state.upscalingResponseErrorMessage = payload;
  state.upscalingIsLoading = false;
};

export const imgUpscalingSlice = createSlice({
  name: 'imageupscaling',
  initialState: imageUpscalingInitialState,

  reducers: {
    upscalingResetTaskDetails(state) {
      state.upscalingTaskDetails = null;
      state.upscalingTaskStatus = null;
    },

    upscalingResetTaskList(state) {
      state.upscalingTaskList = [];
    },
  },

  extraReducers: builder => {
    builder
      .addCase(createImgUpscalingTaskFromGallery.pending, handlePending)
      .addCase(createImgUpscalingTaskFromGallery.rejected, handleRejected)
      .addCase(createImgUpscalingTaskFromGallery.fulfilled, state => {
        state.upscalingIsLoading = false;
        state.upscalingResponseErrorMessage = null;
      })
      .addCase(createImgUpscalingTaskFromUploaded.pending, handlePending)
      .addCase(createImgUpscalingTaskFromUploaded.rejected, handleRejected)
      .addCase(createImgUpscalingTaskFromUploaded.fulfilled, state => {
        state.upscalingIsLoading = false;
        state.upscalingResponseErrorMessage = null;
      })
      .addCase(getImgUpscalingTaskList.pending, handlePending)
      .addCase(getImgUpscalingTaskList.rejected, handleRejected)
      .addCase(getImgUpscalingTaskList.fulfilled, (state, { payload }) => {
        if (payload.length > 0) {
          state.upscalingTaskList = payload;
        } else {
          state.upscalingTaskList = [defaultTask];
        }

        state.upscalingIsLoading = false;
        state.upscalingResponseErrorMessage = null;
      })
      .addCase(goToTheImgUpscalingTask.pending, handlePending)
      .addCase(goToTheImgUpscalingTask.rejected, handleRejected)
      .addCase(goToTheImgUpscalingTask.fulfilled, (state, { payload }) => {
        state.upscalingTaskDetails = payload;
        state.upscalingTaskStatus = payload.status;
        state.upscalingIsLoading = false;
        state.upscalingResponseErrorMessage = null;
      })
      .addCase(removeImgUpscalingTask.pending, handlePending)
      .addCase(removeImgUpscalingTask.rejected, handleRejected)
      .addCase(removeImgUpscalingTask.fulfilled, (state, { payload }) => {
        state.upscalingTaskList = state.upscalingTaskList.filter(
          task => task.id !== payload
        );
        state.upscalingIsLoading = false;
        state.upscalingResponseErrorMessage = null;
      })
      .addCase(sendImgUpscalingImageFeedback.pending, handlePending)
      .addCase(sendImgUpscalingImageFeedback.rejected, handleRejected)
      .addCase(
        sendImgUpscalingImageFeedback.fulfilled,
        (state, { payload }) => {
          const imageArrCopy = [...state.upscalingTaskDetails.images];
          const updatedImage = state.upscalingTaskDetails.images.find(
            el => el.id === payload.imageId
          );
          if (updatedImage) updatedImage.feedback = payload.value;

          state.upscalingTaskDetails.images = imageArrCopy;
          state.upscalingIsLoading = false;
          state.upscalingResponseErrorMessage = null;
        }
      );
  },
});

export const { upscalingResetTaskDetails, upscalingResetTaskList } =
  imgUpscalingSlice.actions;
export const imgUpscalingReducer = imgUpscalingSlice.reducer;
